import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function ChevronRightSmall({
  className,
  fillPrimary = colors.neutral50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[16px] w-[16px]', className)}
    >
      <g id="ic-chevron-right-sm">
        <path
          id="Vector 10 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29289 13.7071C8.90237 13.3166 8.90237 12.6834 9.29289 12.2929L13.5858 8L9.29289 3.70711C8.90237 3.31658 8.90237 2.68342 9.29289 2.29289C9.68342 1.90237 10.3166 1.90237 10.7071 2.29289L15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071Z"
          fill={fillPrimary}
        />
      </g>
    </svg>
  );
}
